/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      ipAddress
      contacts {
        items {
          id
          firstName
          lastName
          email
          message
          createdAt
          updatedAt
          userContactsId
        }
        nextToken
      }
      investors {
        items {
          id
          firstName
          lastName
          email
          message
          isAccredited
          createdAt
          updatedAt
          userInvestorsId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      ipAddress
      contacts {
        items {
          id
          firstName
          lastName
          email
          message
          createdAt
          updatedAt
          userContactsId
        }
        nextToken
      }
      investors {
        items {
          id
          firstName
          lastName
          email
          message
          isAccredited
          createdAt
          updatedAt
          userInvestorsId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      ipAddress
      contacts {
        items {
          id
          firstName
          lastName
          email
          message
          createdAt
          updatedAt
          userContactsId
        }
        nextToken
      }
      investors {
        items {
          id
          firstName
          lastName
          email
          message
          isAccredited
          createdAt
          updatedAt
          userInvestorsId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userContactsId
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userContactsId
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userContactsId
    }
  }
`;
export const createInvestor = /* GraphQL */ `
  mutation CreateInvestor(
    $input: CreateInvestorInput!
    $condition: ModelInvestorConditionInput
  ) {
    createInvestor(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      isAccredited
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userInvestorsId
    }
  }
`;
export const updateInvestor = /* GraphQL */ `
  mutation UpdateInvestor(
    $input: UpdateInvestorInput!
    $condition: ModelInvestorConditionInput
  ) {
    updateInvestor(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      isAccredited
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userInvestorsId
    }
  }
`;
export const deleteInvestor = /* GraphQL */ `
  mutation DeleteInvestor(
    $input: DeleteInvestorInput!
    $condition: ModelInvestorConditionInput
  ) {
    deleteInvestor(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      message
      isAccredited
      user {
        id
        ipAddress
        contacts {
          nextToken
        }
        investors {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      userInvestorsId
    }
  }
`;
